
import Vue from 'vue';
import Router from 'vue-router';
import Cookie from '@/common/util/cookie';

Vue.use(Router);

import App from '@/App';
import NnFound from '@/views/Unfound';

// l1-l3
const Lower = r => require.ensure([], () => r(require('@/views/habit/lower/lower')), 'Lower');
// l7-l9
const Higher = r => require.ensure([], () => r(require('@/views/habit/higher/higher')), 'Higher');
// 表达
const Expression = r => require.ensure([], () => r(require('@/views/habit/expression/expression')), 'Expression');


// 用户中心-首页
const UserCenter = r => require.ensure([], () => r(require('@/views/UserCenter')), 'UserCenter');;
const UserHome = r => require.ensure([], () => r(require('@/views/user/userHome/userHome')), 'UserHome');
// 用户中心-手机号登录
const UserPhoneLogin = r => require.ensure([], () => r(require('@/views/user/userPhoneLogin/userPhoneLogin')), 'UserPhoneLogin');
// 用户中心作业答案
const Answer = r => require.ensure([], () => r(require('@/views/user/answer/answer')), 'Answer');
// 用户中心-学而思账号登录
const UserXesLogin = r => require.ensure([], () => r(require('@/views/user/userxesLogin/userxesLogin')), 'UserXesLogin');
// 绑定手机号
const UserBindPhone = r => require.ensure([], () => r(require('@/views/user/userBindPhone/userBindPhone')), 'UserBindPhone');
// 用户中心-完善信息
const CompleteInfo = r => require.ensure([], () => r(require('@/views/user/completeInfo/completeInfo')), 'CompleteInfo');
// 用户中心-表单
const UserInfo = r => require.ensure([], () => r(require('@/views/user/userInfo/userInfo')), 'UserInfo');
//用户中心-表单详细信息
const UserSex = r => require.ensure([], () => r(require('@/views/user/userSex/userSex')), 'UserSex');
const UserSwitchPhone = r => require.ensure([], () => r(require('@/views/user/userSwitchPhone/userSwitchPhone')), 'UserSwitchPhone');
const UserMail = r => require.ensure([], () => r(require('@/views/user/userMail/userMail')), 'UserMail');
//切换学员编号
const SwitchStuNum = r => require.ensure([],() => r(require('@/views/user/switchStuNum/switchStuNum')),'SwitchStuNum');
// const UserNum = r => require.ensure([], () => r(require('@/views/user/userNum/userNum')), 'UserNum');
//资料下载
const UserDocument = r => require.ensure([], () => r(require('@/views/user/userDocument/userDocument')), 'UserDocument');
const UserDownload = r => require.ensure([], () => r(require('@/views/user/userDownload/userDownload')), 'UserDownload');
const DownloadSelect = r => require.ensure([], () => r(require('@/views/user/downloadSelect/downloadSelect')), 'DownloadSelect');
const DocQrCode = r => require.ensure([],() => r(require('@/views/user/docQrCode/docQrCode')),'DocQrCode');
//考试
const ExamCard = r => require.ensure([], () => r(require('@/views/user/examCard/examCard')), 'ExamCard');
const ExamInfo = r => require.ensure([], () => r(require('@/views/user/examInfo/examInfo')), 'ExamInfo');
const ExamNotice = r => require.ensure([], () => r(require('@/views/user/examNotice/examNotice')), 'ExamNotice');
const ExamQuery = r => require.ensure([], () => r(require('@/views/user/examQuery/examQuery')), 'ExamQuery');
const ScheduleQuery = r => require.ensure([], () => r(require('@/views/user/scheduleQuery/scheduleQuery')), 'ScheduleQuery');
const ClassList = r => require.ensure([], () => r(require('@/views/user/classList/classList')), 'ClassList');
const TestList = r => require.ensure([], () => r(require('@/views/user/testList/testList')), 'TestList');
const IfsReport = r => require.ensure([], () => r(require('@/views/user/ifsReport/ifsReport')), 'IfsReport');
const Follow = r => require.ensure([], () => r(require('@/views/user/follow/follow')), 'Follow');
// h5运营活动
const Huodong = r => require.ensure([], () => r(require('@/views/Huodong')), 'Huodong');
// 活动报名
// const SignUp = r => require.ensure([], () => r(require('@/views/activity/signUp/signUp')), 'SignUp');
const SelectSpace = r => require.ensure([], () => r(require('@/views/activity/selectSpace/selectSpace')), 'SelectSpace');
const Content = r => require.ensure([], () => r(require('@/views/activity/content/content')), 'Content');
// const XesLogin = r => require.ensure([], () => r(require('@/views/activity/xesLogin/xesLogin')), 'XesLogin');
// 本地图文
const Imagetext = r => require.ensure([], () => r(require('@/views/Imagetext')), 'Imagetext');
const Wximagetext = r => require.ensure([], () => r(require('@/views/imagetext/wximagetext/wximagetext')), 'Wximagetext');
const Pcimagetext = r => require.ensure([], () => r(require('@/views/imagetext/pcimagetext/pcimagetext')), 'Pcimagetext');
// const XesLogin = r => require.ensure([], () => r(require('@/views/activity/xesLogin/xesLogin')), 'XesLogin');
const ActXesLogin = r => require.ensure([], () => r(require('@/views/activity/actXesLogin/actXesLogin')), 'ActXesLogin');
const ActPhoneLogin = r => require.ensure([], () => r(require('@/views/activity/actPhoneLogin/actPhoneLogin')), 'ActPhoneLogin');
const ActBindPhone = r => require.ensure([], () => r(require('@/views/activity/actBindPhone/actBindPhone')), 'ActBindPhone');
const ActCompInfo = r => require.ensure([], () => r(require('@/views/activity/actCompInfo/actCompInfo')), 'ActCompInfo');

// 21天训练营
const Habit = r => require.ensure([], () => r(require('@/views/Habit')), 'Habit');
const Introduce = r => require.ensure([], () => r(require('@/views/habit/introduce/introduce')), 'Habit');
const IntroduceMore = r => require.ensure([], () => r(require('@/views/habit/introduce/introduceMore/introduceMore')), 'Habit');
const Center = r => require.ensure([], () => r(require('@/views/habit/user/HabitCenter')), 'Habit');
const Card = r => require.ensure([], () => r(require('@/views/habit/user/card/card')), 'Habit');
const CardShare = r => require.ensure([], () => r(require('@/views/habit/user/cardShare/cardShare')), 'Habit');
const Journal = r => require.ensure([], () => r(require('@/views/habit/user/journal/journal')), 'Habit');
const ExamsResult = r => require.ensure([], () => r(require('@/views/habit/ExamsResult/examResult')), 'ExamsResult');
const GuideIllustration = r => require.ensure([], () => r(require('@/views/habit/guide/guide')), 'GuideIllustration');
const Sleep = r => require.ensure([], () => r(require('@/views/habit/sleep/sleep')), 'Sleep');
const ChengYu = r => require.ensure([], () => r(require('@/views/habit/chengyu/chengyu')), 'ChengYu');
// 助力活动
const zhuli = r => require.ensure([], () => r(require('@/views/habit/zhuli/zhuli')), 'zhuli');
const list = r => require.ensure([], () => r(require('@/views/habit/zhuli/list')), 'list');
const Detail = r => require.ensure([], () => r(require('@/views/habit/zhuli/detail')), 'Detail');
const Address = r => require.ensure([], () => r(require('@/views/habit/zhuli/address')), 'Address');
const Share = r => require.ensure([], () => r(require('@/views/habit/zhuli/share')), 'Share');
const ExchangePrize = r => require.ensure([], () => r(require('@/views/habit/zhuli/exchangeprize')), 'ExchangePrize');
const GuShi = r => require.ensure([], () => r(require('@/views/habit/gushi/gushi')), 'GuShi');
const CiYu = r => require.ensure([], () => r(require('@/views/habit/ciyu/ciyu')), 'CiYu');
const KaiDiKe = r => require.ensure([], () => r(require('@/views/habit/kaidike/kaidike')), 'KaiDiKe');

//上海故事大赛
const Video = r => require.ensure([], () => r(require('@/views/habit/video/uploadIntroduce.vue')), 'ShVideo');
const VideoList = r => require.ensure([], () => r(require('@/views/habit/video/videolist.vue')), 'ShVideo');
// 大赛
const Lecturer = r => require.ensure([], () => r(require('@/views/habit/huodong/competition/uploadIntroduce.vue')), 'MwLecturer');
const LecturerList = r => require.ensure([], () => r(require('@/views/habit/huodong/competition/videolist.vue')), 'MwLecturerList');
const lectureShare = r => require.ensure([], () => r(require('@/views/habit/huodong/competition/lectureShare.vue')), 'MwLecturerShare');
const lectureTime = r => require.ensure([], () => r(require('@/views/habit/huodong/competition/lectureTime.vue')), 'MwLecturerTime');
const lectureSubjects = r => require.ensure([], () => r(require('@/views/habit/huodong/competition/lectureSubjects.vue')), 'MwLecturerSubject');
const videoUpload = r => require.ensure([], () => r(require('@/views/habit/huodong/competition/videoupload.vue')), 'videoupload');
// 上海新版萌娃
const Lecturersh = r => require.ensure([], () => r(require('@/views/habit/huodong/mwcompetition/uploadIntroduce.vue')), 'MwLecturersh');
const LecturerListsh = r => require.ensure([], () => r(require('@/views/habit/huodong/mwcompetition/videolist.vue')), 'MwLecturerListsh');
const lectureSharesh = r => require.ensure([], () => r(require('@/views/habit/huodong/mwcompetition/lectureShare.vue')), 'MwLecturerSharesh');
const lectureTimesh = r => require.ensure([], () => r(require('@/views/habit/huodong/mwcompetition/lectureTime.vue')), 'MwLecturerTimesh');
const lectureSubjectssh = r => require.ensure([], () => r(require('@/views/habit/huodong/mwcompetition/lectureSubjects.vue')), 'MwLecturerSubjectsh');
const videoUploadsh = r => require.ensure([], () => r(require('@/views/habit/huodong/mwcompetition/videoupload.vue')), 'videouploadsh');
//广州故事大赛
//广州故事大赛
const Guangzhou = r => require.ensure([], () => r(require('@/views/habit/guangzhou/uploadIntroduce.vue')), 'GzVideo');
const GuangzhouList = r => require.ensure([], () => r(require('@/views/habit/guangzhou/guangzhoulist.vue')), 'GzVideo');
const afterShare = r => require.ensure([], () => r(require('@/views/habit/afterShare/afterShare.vue')), 'afterShare');
// 21天运营活动
const Christmas = r => require.ensure([], () => r(require('@/views/habit/huodong/christmas/christmas')), 'Christmas');
const ChristmasShare = r => require.ensure([], () => r(require('@/views/habit/huodong/christmasShare/christmasShare')), 'christmasShare');
const kaidikeBook = r => require.ensure([], () => r(require('@/views/habit/huodong/kaidikeBook/kaidikeBook')), 'kaidikeBook');
const Prize = r => require.ensure([], () => r(require('@/views/habit/huodong/prize/prize')), 'Prize');
const PrizeShare = r => require.ensure([], () => r(require('@/views/habit/huodong/prize/prizeshare')), 'PrizeShare');
const ExpressionAbility = r => require.ensure([], () => r(require('@/views/habit/huodong/expression/expression')), 'ExpressionAbility');
const Mengmeng = r => require.ensure([], () => r(require('@/views/habit/huodong/mengmeng/mengmeng')), 'Mengmeng');
const Sidamingzhu = r => require.ensure([], () => r(require('@/views/habit/huodong/sidamingzhu/sidamingzhu')), 'Sidamingzhu');
const UnivDream = r => require.ensure([], () => r(require('@/views/habit/huodong/universityDream/universityDream')), 'UnivDream');
const UnivDreamShare = r => require.ensure([], () => r(require('@/views/habit/huodong/universityDreamShare/universityDreamShare')), 'UnivDreamShare');

//二维码页面
const logicerweima = r => require.ensure([], () => r(require('@/views/habit/logicerweima/logicerweima.vue')), 'logicerweima');


//21天训练营-我的
const My = r => require.ensure([], () => r(require('@/views/habit/user/my/my')), 'My');
const UserPoint = r => require.ensure([], () => r(require('@/views/habit/user/my/userPoint/userPoint')), 'UserPoint');
const UserSuggest = r => require.ensure([], () => r(require('@/views/habit/user/my/userSuggest/userSuggest')), 'UserSuggest');
const TFUserInfo = r => require.ensure([], () => r(require('@/views/habit/user/tfuserInfo/tfuserInfo')), 'TFUserInfo');
const TFUserName = r => require.ensure([], () => r(require('@/views/habit/user/tfuserInfo/tfuserName/tfuserName')), 'TFUserName');
// 21天训练营-老师点评
const Remark = r => require.ensure([], () => r(require('@/views/habit/remark/remark')), 'Remark');
const UnRemark = r => require.ensure([], () => r(require('@/views/habit/remark/unremark/unremark')), 'UnRemark');

// 21天积分商城
const DaysMall = r => require.ensure([], () => r(require('@/views/habit/pointMall/pointMall')), 'DaysMall');
//21天预览
const ExpressionPrev = r => require.ensure([], () => r(require('@/views/preview/expression/expression')), 'ExpressionPrev');
const LowerPrev = r => require.ensure([], () => r(require('@/views/preview/lower/lower')), 'LowerPrev');
const CenterPrev = r => require.ensure([], () => r(require('@/views/preview/user/HabitCenter')), 'Preview');

// 小程序h5辅助展示，分享朋友圈
const Miniapp = r => require.ensure([], () => r(require('@/views/Miniapp')), 'Miniapp');
const Trainapp = r => require.ensure([], () => r(require('@/views/miniapp/Trainapp')), 'Trainapp');

// h5 demo
const Demo = r => require.ensure([], () => r(require('@/views/Demo')), 'Demo');
const PinYin = r => require.ensure([], () => r(require('@/views/habit/pinyin/pinyin')), 'PinYin');

// 七大能力
const AbilityIntro = r => require.ensure([], () => r(require('@/views/sevenAbility/introduce/introduce')), 'AbilityIntro');
const AbilityGames = r => require.ensure([], () => r(require('@/views/sevenAbility/abilityGames/abilityGames')), 'AbilityGames');
const TestSheep = r => require.ensure([], () => r(require('@/views/sevenAbility/abilityGames/findSheeps/findSheep')), 'TestSheep');
const AbilityResult = r => require.ensure([], () => r(require('@/views/sevenAbility/abilityResult/abilityResult')), 'AbilityResult');

// 新年活动
const HappyNewYear2018 = r => require.ensure([], () => r(require('@/views/habit/huodong/happyNewYear2018/happyNewYear')), 'HappyNewYear2018');
const HappyNewYear2018Share = r => require.ensure([], () => r(require('@/views/habit/huodong/happyNewYear2018Share/happyNewYearShare')), 'HappyNewYear2018Share');
const NewYear2018Gift = r => require.ensure([], () => r(require('@/views/habit/huodong/newYear2018Gift/newYear2018Gift')), 'NewYear2018Gift');
export default new Router({
    mode: 'history', // 删除url中的#
    routes: [
        {
            path: '/',
            component: App,
        },
        //PC端二维码
        {
            path: '/docqrcode',
            component: DocQrCode,
            meta: {
                title: '文件二维码'
            },
            beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            },
        },
        // 用户中心-首页
        {
            path: '/user',
            component: UserCenter,
            children: [
                // 中心
                {
                    path: 'home',
                    component: UserHome,
                    meta: {
                        title: '我的中心'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 手机号登录
                {
                    path: 'phonelogin',
                    component: UserPhoneLogin,
                    meta:{
                        title: '手机号登录'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 作业答案
                {
                    path: 'answer',
                    component: Answer,
                    meta:{
                        title: '巩固答案'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 完善信息
                {
                    path: 'compinfo',
                    component: CompleteInfo,
                    meta:{
                        title: '完善信息'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 学而思账号登录
                {
                    path: 'xeslogin',
                    component: UserXesLogin,
                    meta: {
                        title: '学而思账号登录'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 表单
                {
                    path: 'info',
                    component: UserInfo,
                    meta: {
                        title: '个人信息'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                //性别
                {
                    path:'sex',
                    component: UserSex,
                    meta: {
                        title: '选择性别'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 切换手机
                {
                    path:'switchphone',
                    component: UserSwitchPhone,
                    meta: {
                        title: '切换手机号'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 绑定手机
                {
                    path:'bindphone',
                    component: UserBindPhone,
                    meta: {
                        title: '绑定手机号'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                //邮箱
                {
                    path:'mail',
                    component: UserMail,
                    meta: {
                        title: '填写邮箱'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                //切换学员编号
                {
                    path:'stunum',
                    component: SwitchStuNum,
                    meta:{
                        title:'切换学员编号'
                    },
                    beforeEnter(to,from,next){
                        document.title=to.meta.title;
                        next();
                    },
                },
                //我的资料下载
                {
                    path: 'document',
                    component: UserDocument,
                    meta: {
                        title: '我的资料'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                //素材管理
                {
                    path: 'material',
                    component: UserDownload,
                    meta: {
                        title: '资料下载'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                //下载选择
                {
                    path: 'select',
                    component: DownloadSelect,
                    meta: {
                        title: '文件详情'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'examcard',
                    component: ExamCard,
                    meta: {
                        title: '准考证'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'examinfo',
                    component: ExamInfo,
                    meta: {
                        title: '考场信息'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                    beforeLeave (to, from, next) {
                        console.log(to)
                        console.log(form)
                        next();
                    }
                },
                {
                    path: 'examNotice',
                    component: ExamNotice,
                    meta: {
                        title: '考场信息'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'examquery',
                    component: ExamQuery,
                    meta: {
                        title: '考场列表'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        if (from.fullPath.indexOf('classLIst') > -1) {
                            window.location.href = '/user/examquery'
                        } else {
                            next();
                        }

                    },
                },
                {
                    path: 'scheduleQuery',
                    component: ScheduleQuery,
                    meta: {
                        title: '课表查询'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'classList',
                    component: ClassList,
                    meta: {
                        title: '课次列表'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        console.log(from)
                        if (from.fullPath.indexOf('gotoWhere=1') > -1) {
                            // this.$router.go('/user/examquery')
                            window.location.href = '/user/examquery'
                        } else {
                            next();
                        }
                        next();
                    },
                },
                {
                    path: 'testlist',
                    component: TestList,
                    meta: {
                        title: '考试列表'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'ifsreport',
                    component: IfsReport,
                    meta: {
                        title: 'IFS成绩报告'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'follow',
                    component: Follow,
                    meta: {
                        title: '关注公众号'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
            ]
        },
        // 本地图文
        {
            path: '/pictext',
            component: Imagetext,
            children: [
                {
                    path: 'wximgtext',
                    component: Wximagetext
                },
                {
                    path: 'pcimgtext',
                    component: Pcimagetext
                }
            ]
        },
        // wxh5 活动
        {
            path: '/huodong',
            component: Huodong,
            children: [
                // 活动-手机号登录
                {
                    path: 'phonelogin',
                    component: ActPhoneLogin,
                    meta: {
                        title: '手机号登录'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 活动-学而思账号登录
                {
                    path: 'xeslogin',
                    component: ActXesLogin,
                    meta: {
                        title: '学而思账号登录'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 活动-绑定手机号
                {
                    path: 'bindphone',
                    component: ActBindPhone,
                    meta: {
                        title: '绑定手机号'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 活动-完善信息页
                {
                    path: 'compinfo',
                    component: ActCompInfo,
                    meta: {
                        title: '报名信息完善'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                //活动页面-选择场次
                {
                    path: 'selectspace',
                    component: SelectSpace,
                    meta: {
                        title: '报名'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                //活动页面-内容
                {
                    path: 'content',
                    component: Content,
                    meta: {
                        title: '活动报名'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
            ]
        },
        // 21天
        {
            path: '/habit',
            component: Habit,
            children: [
                {
                    path: 'introduce',
                    component: Introduce,
                    meta: {
                        title: '21天表达训练营'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'more',
                    component: IntroduceMore,
                    meta: {
                        title: '21天表达训练营'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'center',
                    component: Center,
                    meta: {
                        title: '21天表达训练营'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                    children: [
                        {
                            path: 'expression',
                            component: Expression,
                            meta: {
                                title: '21天表达训练营'
                            },
                            beforeEnter(to, from, next) {
                                document.title = to.meta.title;
                                let phone = Cookie.get('cGlk');
                                if (!phone) {
                                    // 未登录，去活动介绍页面
                                    location.href = '/habit/introduce';
                                } else {
                                    next();
                                }
                            }
                        },
                        {
                            path: 'card',
                            component: Card,
                            meta: {
                                title: '我的打卡'
                            },
                            beforeEnter(to, from, next) {
                                document.title = to.meta.title;
                                let phone = Cookie.get('cGlk');
                                if (!phone) {
                                    // 未登录，去活动介绍页面
                                    location.href = '/habit/introduce';
                                } else {
                                    next();
                                }
                            },
                        },
                        {
                            path: 'journal',
                            component: Journal,
                            meta: {
                                title: '成长日记'
                            },
                            beforeEnter(to, from, next) {
                                document.title = to.meta.title;
                                let phone = Cookie.get('cGlk');
                                if (!phone) {
                                    // 未登录，去活动介绍页面
                                    location.href = '/habit/introduce';
                                } else {
                                    next();
                                }
                            },
                        },
                        {
                            path: 'my',
                            component: My,
                            meta: {
                                title: '个人中心'
                            },
                            beforeEnter(to, from, next) {
                                document.title = to.meta.title;
                                let phone = Cookie.get('cGlk');
                                if (!phone) {
                                    // 未登录，去活动介绍页面
                                    location.href = '/habit/introduce';
                                } else {
                                    next();
                                }
                            }
                        },
                    ]
                },
                {
                    path: 'lower',
                    component: Lower,
                    meta: {
                        title: '看绘本听音频'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        let phone = Cookie.get('cGlk');
                        if (!phone) {
                            // 未登录，去活动介绍页面
                            location.href = '/habit/introduce';
                        } else {
                            next();
                        }
                    }
                },
                {
                    path: 'higher',
                    component: Higher,
                    meta: {
                        title: '看视频，录观点'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        let phone = Cookie.get('cGlk');
                        if (!phone) {
                            // 未登录，去活动介绍页面
                            location.href = '/habit/introduce';
                        } else {
                            next();
                        }
                    }
                },
                { // 答题记录
                    path: 'result',
                    component: ExamsResult,
                    meta: {
                        title: '答题记录'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        let phone = Cookie.get('cGlk');
                        if (!phone) {
                            // 未登录，去活动介绍页面
                            location.href = '/habit/introduce';
                        } else {
                            next();
                        }
                    },
                },
                {
                    path: 'tfuserinfo' ,
                    component: TFUserInfo,
                    meta: {
                        title: '我的信息'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        let phone = Cookie.get('cGlk');
                        if (!phone) {
                            // 未登录，去活动介绍页面
                            location.href = '/habit/introduce';
                        } else {
                            next();
                        }
                    }
                },
                {
                    path: 'tfusername',
                    component: TFUserName,
                    meta: {
                        title: '编辑姓名'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        let phone = Cookie.get('cGlk');
                        if (!phone) {
                            // 未登录，去活动介绍页面
                            location.href = '/habit/introduce';
                        } else {
                            next();
                        }
                    }
                },
                {
                    path: 'point',
                    component: UserPoint,
                    meta: {
                        title: '我的积分'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        let phone = Cookie.get('cGlk');
                        if (!phone) {
                            // 未登录，去活动介绍页面
                            location.href = '/habit/introduce';
                        } else {
                            next();
                        }
                    }

                },
                {
                    path: 'suggest',
                    component: UserSuggest,
                    meta: {
                        title: '意见反馈'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        let phone = Cookie.get('cGlk');
                        if (!phone) {
                            // 未登录，去活动介绍页面
                            location.href = '/habit/introduce';
                        } else {
                            next();
                        }
                    }
                },
                {
                    path: 'share',
                    component: CardShare,
                    meta: {
                        title: '分享成就'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 表达指导
                {
                    path: 'guide',
                    component: GuideIllustration,
                    meta: {
                        title: '21天表达秘籍'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 表达指导
                {
                    path: 'sleep',
                    component: Sleep,
                    meta: {
                        title: '恭喜您获得睡前故事'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'chengyu',
                    component: ChengYu,
                    meta: {
                        title: '恭喜您获得成语故事'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'kaidike',
                    component: KaiDiKe,
                    meta: {
                        title: '恭喜您获得凯迪克大奖绘本'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'gushi',
                    component: GuShi,
                    meta: {
                        title: '恭喜您获得小学必背古诗'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },

                },
                {
                    path: 'ciyu',
                    component: CiYu,
                    meta: {
                        title: '恭喜您获得小学必备词语句式'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },

                },
                // 老师评价页面
                {
                    path: 'remark',
                    component: Remark,
                    meta: {
                        title: '点评订单'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 老师未评价列表
                {
                    path: 'unremark',
                    component: UnRemark,
                    meta: {
                        title: '未点评订单'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                // 21天积分商城
                {
                    path: 'mall',
                    component: DaysMall,
                    meta: {
                        title: '积分商城'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'video',
                    component: Video,
                    meta: {
                        title: '学而思学前第一届故事大赛'
                    },
                    query: {
                        id: 0
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'videoupload',
                    component: videoUpload,
                    query: {
                        status: 1,
                        videoUrl: ''
                    },
                    meta: {
                        title: '提交视频'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    }
                },
                {
                    path: 'lecturer',
                    component: Lecturer,
                    meta: {
                        title: '学而思萌娃小讲师活动'
                    },
                    query: {
                        id: 0
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'lecshare',
                    component: lectureShare,
                    meta: {
                        title: '学而思萌娃小讲师活动'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'schedule',
                    component: lectureTime,
                    meta: {
                        title: '时间安排'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'subjects',
                    component: lectureSubjects,
                    meta: {
                        title: '萌娃题库'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'lecturerupload',
                    component: LecturerList,
                    query: {
                        status: 1,
                        videoUrl: ''
                    },
                    meta: {
                        title: '提交视频'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'uploadvideo',
                    component: lectureSubjects,
                    meta: {
                        title: '提交视频'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },   
                {
                    path: 'lecturersh',
                    component: Lecturersh,
                    meta: {
                        title: '学而思萌娃小讲师活动'
                    },
                    query: {
                        id: 0
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'lecsharesh',
                    component: lectureSharesh,
                    meta: {
                        title: '学而思萌娃小讲师活动'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'schedulesh',
                    component: lectureTimesh,
                    meta: {
                        title: '时间安排'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'subjectssh',
                    component: lectureSubjectssh,
                    meta: {
                        title: '萌娃题库'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'lectureruploadsh',
                    component: LecturerListsh,
                    query: {
                        status: 1,
                        videoUrl: ''
                    },
                    meta: {
                        title: '提交视频'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'uploadvideosh',
                    component: lectureSubjectssh,
                    meta: {
                        title: '提交视频'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'guangzhou',
                    component: Guangzhou,
                    meta: {
                        title: '广州表达之星'
                    },
                    query: {
                        id: 0
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'guangzhouupload',
                    component: GuangzhouList,
                    query: {
                        status: 1,
                        videoUrl: ''
                    },
                    meta: {
                        title: '提交视频'
                    },
                    beforeEnter(to, from, next) {
                        // document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'aftershare',
                    component: afterShare,
                    query: {
                        shs_user_id: ''
                    },
                    meta: {
                       title: '广州表达之星'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'christmas',
                    component: Christmas,
                    meta: {
                       title: '定制你的圣诞祝福'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'chrisshare',
                    component: ChristmasShare,
                    meta: {
                       title: '定制你的圣诞祝福'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'kaidikebook',
                    component: kaidikeBook,
                    meta: {
                       title: '凯迪克大奖绘本'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'mengmeng',
                    component: Mengmeng,
                    meta: {
                       title: '成语微课资料包'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'sidamingzhu',
                    component: Sidamingzhu,
                    meta: {
                       title: '四大名著全面解析资料包'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'expressionability',
                    component: ExpressionAbility,
                    meta: {
                       title: '表达能力微课'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'prize',
                    component: Prize,
                    meta: {
                       title: '21天训练营'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'prizeshare',
                    component: PrizeShare,
                    meta: {
                       title: '21天训练营'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'logicerweima',
                    component: logicerweima,
                    meta: {
                       title: '21天训练营pro'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'zhuli',
                    component: zhuli,
                    meta: {
                        title: '21天训练营礼物中心'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                    children: [
                        // 助力活动
                        {
                            path: 'list',
                            component: list,
                            meta: {
                                title: '21天训练营礼物中心'
                            },
                            beforeEnter(to, from, next) {
                                document.title = to.meta.title;
                                next();
                            },
                        },
                        // 详情页
                        {
                            path: 'detail',
                            component: Detail,
                            meta: {
                                title: '21天训练营礼品中心'
                            },
                            beforeEnter(to, from, next) {
                                document.title = to.meta.title;
                                let phone = Cookie.get('cGlk');
                                if (!phone) {
                                //     // 未登录，去首页
                                    location.href = '/habit/zhuli/list';
                                } else {
                                    next();
                                }
                            },
                        },
                        // 地址页面
                        {
                            path: 'address',
                            component: Address,
                            meta: {
                                title: '21天训练营'
                            },
                            beforeEnter(to, from, next) {
                                document.title = to.meta.title;
                                let phone = Cookie.get('cGlk');
                                if (!phone) {
                                //     // 未登录，去首页
                                    location.href = '/habit/zhuli/list';
                                } else {
                                    next();
                                }
                            },
                        },
                        {
                            path: 'share',
                            component: Share,
                            meta: {
                                title: '21天训练营'
                            },
                            beforeEnter(to, from, next) {
                                document.title = to.meta.title;
                                next();
                            },
                        },
                        {
                            path: 'exchangeprize',
                            component: ExchangePrize,
                            meta: {
                                title: '21天训练营礼物中心'
                            },
                            beforeEnter(to, from, next) {
                                document.title = to.meta.title;
                                next();
                            },
                        }

                    ]
                },
                // 新年换装
                {
                    path: 'happy2018',
                    component: HappyNewYear2018,
                    meta: {
                       title: '定制你的新年祝福'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'newyearshare',
                    component: HappyNewYear2018Share,
                    meta: {
                       title: '定制你的新年祝福'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'newyeargift',
                    component: NewYear2018Gift,
                    meta: {
                       title: '定制你的新年祝福'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'univdreamshare',
                    component: UnivDreamShare,
                    meta: {
                       title: '我有一个大学梦'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'univdream',
                    component: UnivDream,
                    meta: {
                       title: '我有一个大学梦'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                }
            ]
        },

        //21天preview
        {
            path: '/preview',
            component: Habit,
            children: [
                {
                    path: 'center',
                    component: CenterPrev,
                    meta: {
                        title: '21天表达训练营'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                        children: [
                            {
                                path: 'exprssionprev',
                                component: ExpressionPrev,
                                query: { classId: 123 },
                                meta: {
                                    title: '21天表达训练营-预览'
                                },
                                beforeEnter(to, from, next) {
                                    document.title = to.meta.title;
                                    next();
                                },
                            }
                        ]
                },
                {
                    path: 'lowerprev',
                    component: LowerPrev,
                    meta: {
                        title: '看绘本听音频-预览'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                }
            ]
        },
        //7大能力
        {
            path: '/sevenability',
            component: Habit,
            children: [
                {
                    path: 'introduce',
                    component: AbilityIntro,
                    meta: {
                        title: '幼儿思维能力评估'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                },
                {
                    path: 'game',
                    component: AbilityGames,
                    meta: {
                        title: '幼儿思维能力评估'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                        let phone = Cookie.get('cGlk');
                        if (!phone) {
                            // 未登录，去活动介绍页面
                            location.href = '/sevenability/introduce';
                        } else {
                            next();
                        }
                    },
                },
                {
                    path: 'report',
                    component: AbilityResult,
                    meta: {
                        title: '幼儿思维能力评估'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                }
           ]
        },
        {
            path: '/miniapp',
            component: Miniapp,
            children: [
                {
                    path: 'train',
                    component: Trainapp,
                    meta: {
                        title: '训练营'
                    },
                    beforeEnter(to, from, next) {
                        document.title = to.meta.title;
                        next();
                    },
                }
            ]
        },
        // demo
        {
            path: '/demo',
            component: Demo,
            meta: {
                wxshare: 1,
                title: 'h5 demo'
            },
            beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            },
        },
        // 拼音检查
        {
            path: '/pinyin',
            component: PinYin,
            meta: {
                title: '拼音检查'
            },
            beforeEnter(to, from, next) {
                document.title = to.meta.title;
                next();
            },
        },
        {
            path: '/:userCenterId',
            component: UserHome,
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js